

























import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { Vue, Component, Prop } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import InformeEventBus from '../partes/InformeEventBus';

@Component({
  components: {
    FormFieldsContainer,
  },
})
export default class CheckTemperatura extends Vue {
  formFields: FormFieldDefMap = {
    checkSatelite: {
      label: 'Satélite',
      id: 'numero_satelites',
      value: true,
    },
    checkHDOP: {
      label: 'HDOP',
      id: 'hdop',
      value: true,
    },
    checkLongYLat: {
      label: 'Latitud y Longitud',
      id: '',
      value: true,
    },
  };
  checkTemperatura() {
    var check = [];
    if (this.formFields.checkSatelite.value) {
      check.push(this.formFields.checkSatelite.id);
    }
    if (this.formFields.checkHDOP.value) {
      check.push(this.formFields.checkHDOP.id);
    }
    if (this.formFields.checkLongYLat.value) {
      check.push('latitud', 'longitud');
    }

    InformeEventBus.$emit('checkTemperatura', check);
  }
  mounted() {
    this.checkTemperatura();
  }
}
